import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIModule } from '@common/UI/UI.module';
import { DebtsComponent } from './debts.component';
import { DirectivesModule } from '@common/directives/directives.module';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { NgxLoadingModule } from 'ngx-loading';
import { ViewerComponent } from './viewer/viewer.component';


@NgModule({
  declarations: [
    DebtsComponent,
    ViewerComponent,
  ],
  imports: [
    CoreModule,
    CommonModule,
    DirectivesModule,
    UIModule,
    FormsModule,
    NgxLoadingModule
  ]
})
export class DebtsModule { }
